import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ExtMaterialAttrTenantManage ( props ) {

    return <BasicCrudScreenType id="ExtMaterialAttrTenantManage" noExcel table="ExtMaterialAttrTenant" view="VwExtMaterialAttrTenant" />

}

export default ExtMaterialAttrTenantManage;